import { useSetAtom } from "jotai";
import { useEffect, useRef } from "react";

import type { SessionData } from "./session";
import { sessionStateAtom } from "./session";

/**
 * Initialize session from Better Auth on app startup
 * Fetches session once and caches it in the atom
 */
function useInitSession() {
  const setSessionState = useSetAtom(sessionStateAtom);
  const hasInitRef = useRef(false);

  useEffect(() => {
    if (hasInitRef.current) return;
    hasInitRef.current = true;

    const loadSession = async () => {
      try {
        // Dynamic import keeps better-auth out of the critical bundle;
        // it loads post-hydration when the session check runs.
        const { authClient } = await import("@/lib/auth-client");
        const { data: session } = await authClient.getSession();

        if (session) {
          setSessionState({
            data: session as SessionData,
            isPending: false,
          });
        } else {
          setSessionState({ data: null, isPending: false });
        }
      } catch {
        setSessionState({ data: null, isPending: false });
      }
    };

    loadSession();
  }, [setSessionState]);
}

function useInitContextData() {
  useInitSession();
}

export default useInitContextData;
